import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ProductPriceListResponse } from 'src/app/models/price-list.model';
import { InventoryProductWithoutCostResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-cost-list-crud',
  templateUrl: './cost-list-crud.component.html',
  styleUrls: ['./cost-list-crud.component.scss']
})
export class CostListCrudComponent {
  saving = 0;
  productsWithoutCost: InventoryProductWithoutCostResponse[] = [];
  paginationProductsWithoutCost = new PaginationModel(0, 5, 0, 0, [], []);
  loadingProducts = false;
  productPriceList: ProductPriceListResponse;
  showModalCreateList = false;
  nameList: string = null;
  loadingCreate = false;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "Crear", "fa-save");
  filterWord: string = null;
  // pagination = {
  //   total: [],
  //   filter: [],
  //   pageSize: 5,
  //   startElement: 0,
  //   lastElement: 0,
  //   pageIndex: 0
  // }

  constructor(
    private invService: InventoryService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getProductsWithoutCost();
  }
  

  getProductsWithoutCost() {
    this.loadingProducts = true;
    this.productsWithoutCost = [];
    this.invService.getProductsWithoutCost().subscribe({
      next: (response: ResponseObject) => {
        this.loadingProducts = false;
        this.productsWithoutCost = response.data;
        this.paginationProductsWithoutCost.total = JSON.parse(JSON.stringify(this.productsWithoutCost));
        this.paginationProductsWithoutCost = PaginationUtil.reset(this.paginationProductsWithoutCost);
        // this.pagination.filter = this.productsWithoutCost;
        // this.pagination.total = this.productsWithoutCost;
        this.resetPagination();
      },
      error: (error) => {
        this.loadingProducts = false;
        this.toastService.error("Error al obtener los productos sin costo");
      }
    })
  }

  resetPagination() {
    this.paginationProductsWithoutCost.filter = this.paginationProductsWithoutCost.total.slice(0, this.paginationProductsWithoutCost.pageSize);
    this.paginationProductsWithoutCost.pageIndex = 0;
    this.paginationProductsWithoutCost.lastElement = this.paginationProductsWithoutCost.filter.length;
    this.paginationProductsWithoutCost.startElement = 0;
  }

  updateCost(product: InventoryProductWithoutCostResponse) {
    if (product.loading) {
      return;
    }
    product.loading = true;
    this.invService.updateProductCost(product.productId, product.cost).subscribe({
      next: (response: ResponseObject) => {
        product.loading = false;
        this.saving++;
        if (this.saving == this.isWaiting()){
          this.saving = 0;
        }
        this.toastService.info(`Costo del producto ${product.productName} agregado exitosamente!`);
      },
      error: (error) => {
        product.loading = false;
        this.saving++;
        if (this.saving == this.isWaiting()){
          this.saving = 0;
        }
        this.toastService.error("Error al actualizar el costo del producto " + product.productName);
      }
    })
  }

  saveAll() {
    this.saving = 0;
    for (let i = 0; i < this.paginationProductsWithoutCost.filter.length; i++) {
      const element: InventoryProductWithoutCostResponse = this.paginationProductsWithoutCost.filter[i];
      if (element.cost && element.cost > 0) {
        this.updateCost(element);
      }
    }
  }

  isWaiting() {
    var count = 0;
    if (this.paginationProductsWithoutCost.filter.length > 0) {
      for (let i = 0; i < this.paginationProductsWithoutCost.filter.length; i++) {
        const element: InventoryProductWithoutCostResponse = this.paginationProductsWithoutCost.filter[i];
        if (element.cost && element.cost > 0) {
          count++;
        }
      }
      return count;
    } else {
      return count;
    }
  }

  setCurrentList(list: ProductPriceListResponse) {
    if(!list) {
      this.productPriceList = null;
      return;
    }
    this.productPriceList = list;
  }

  openModal(){
    this.showModalCreateList = true;
    this.nameList = null;
  }

  closeModal(event: any){
    this.showModalCreateList = false;
  }

  addList(){
    if (!this.nameList) {
      return
    }
    let data = {name: this.nameList}
    this.loadingCreate = true;
    this.invService.postProductPricesList(data).subscribe({
    next: (response: ResponseObject) => {
      this.saving = this.saving + 1;
      this.toastService.success("Lista agregada.", "Exito");
      this.loadingCreate = false;
      this.closeModal(true);
    },
    error: (error: HttpErrorResponse) => {
      this.toastService.error("Error al agregar Lista.", "Error");
    }
   });
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.paginationProductsWithoutCost.total = this.productsWithoutCost.filter((item) => {
      const filter = this.filterWord.toLowerCase();

      return (
        item.productCode.toLowerCase().includes(filter)|| 
        (item.productBarCode && item.productBarCode.toLowerCase().includes(filter) )||
        item.productName.toLowerCase().includes(filter) 
      );
    });

    this.paginationProductsWithoutCost.pageIndex = 0;
    this.paginationProductsWithoutCost.startElement = 0;
    this.paginationProductsWithoutCost.filter = this.paginationProductsWithoutCost.total.slice(0, this.paginationProductsWithoutCost.pageSize);
    this.paginationProductsWithoutCost.lastElement = this.paginationProductsWithoutCost.filter.length;
  }

}
